import React from 'react';
export function StartupSection() {
  const startups = [{
    id: 1,
    name: 'flAir',
    role: 'Founder and CEO',
    description: 'Developing comprehensive IoT safety brand creating next-generation portable CO and deadly gas detectors with multiple form factors: smart phone cases, AirTag-style trackers, jewelry, and wearables. Built with ESP32-C3 microcontrollers, specialized gas sensors, and rechargeable battery systems.',
    link: 'https://same-xv1lcut1eww-latest.netlify.app/',
    image: 'https://images.unsplash.com/photo-1581092160607-cea11fcb0794?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 2,
    name: 'Scrollogy',
    role: 'Founder and CEO',
    description: 'Educational platform transforming mindless social media scrolling into productive learning with bite-sized, AI-generated video courses in addictive vertical format. Building with React Native and automated content generation pipelines with gamified 15-30 second educational clips.',
    image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80'
  }, {
    id: 3,
    name: 'HoloGeni',
    role: 'Co-Founder, AI + Hardware Engineer',
    description: "Physical AI hologram agent automating customer service for B2B clients. Uses Tavus.io real-time avatar generation, Google Vision API, and Pepper's Ghost projection. Created @ YC Overnight Agents Hackathon. Targeting retail, restaurant, and hospitality markets.",
    image: 'https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80'
  }, {
    id: 4,
    name: 'FitForm Fitness',
    role: 'Co-Founder, AI + Hardware Engineer',
    description: 'AI-powered personal trainer preventing sports injuries through real-time form correction. Winner: Best Use of Same.new at AI Coding Agents Hackathon @ Y Combinator. Built in 8 hours using wearable IMU sensors, computer vision, and AI coaching.',
    link: 'https://fitformfitness.com/',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }];
  return <section id="startups" className="section-spacing bg-background-light" data-id="element-148">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-150">
          Current Startups
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-151">
          Innovative ventures at the intersection of hardware and AI
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-152">
          {startups.map(startup => <div key={startup.id} className="card overflow-hidden hover:translate-y-[-5px]" data-id="element-153">
              <div className="aspect-video overflow-hidden" data-id="element-154">
                <img src={startup.image} alt={startup.name} className="w-full h-full object-cover" data-id="element-155" />
              </div>
              <div className="p-6" data-id="element-156">
                <h3 className="text-xl font-display font-bold mb-1" data-id="element-157">
                  {startup.name}
                </h3>
                <p className="text-primary mb-3" data-id="element-158">{startup.role}</p>
                <p className="text-text-secondary mb-4" data-id="element-159">
                  {startup.description}
                </p>
                {startup.link && <a href={startup.link} target="_blank" rel="noopener noreferrer" className="text-primary font-medium hover:underline" data-id="element-160">
                    Visit Project →
                  </a>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}